import { toast } from "react-toastify";
import { push } from 'react-router-redux';
const CreditabilityConstants = {
    CREDITABILITY_GET_COMPANY_REQUEST: 'CREDITABILITY_GET_COMPANY_REQUEST',
    CREDITABILITY_GET_COMPANY_RESPONSE: 'CREDITABILITY_GET_COMPANY_RESPONSE',
    CREDITABILITY_POST_COMPANY_REQUEST: 'CREDITABILITY_POST_COMPANY_REQUEST',
    CREDITABILITY_POST_COMPANY_RESPONSE: 'CREDITABILITY_POST_COMPANY_RESPONSE',
    CREDITABILITY_POST_CONTACT_REQUEST: 'CREDITABILITY_POST_CONTACT_REQUEST',
    CREDITABILITY_POST_CONTACT_RESPONSE: 'CREDITABILITY_POST_CONTACT_RESPONSE',
    CREDITABILITY_POST_BANKREFERENCE_REQUEST: 'CREDITABILITY_BANKREFERENCE_REQUEST',
    CREDITABILITY_POST_BANKREFERENCE_RESPONSE: 'CREDITABILITY_POST_BANKREFERENCE_RESPONSE',
    CREDITABILITY_POST_TRADEREFERENCE_REQUEST: 'CREDITABILITY_TRADEREFERENCE_REQUEST',
    CREDITABILITY_POST_TRADEREFERENCE_RESPONSE: 'CREDITABILITY_POST_TRADEREFERENCE_RESPONSE',
}
const initialState = {
    creditForm: {}, creditContactForm: {}, isLoading: false, actResult: ''
};

export const actionCreators = {
    getCompanyForm: (param) => (dispatch) => {
        dispatch({ type: CreditabilityConstants.CREDITABILITY_GET_COMPANY_REQUEST, isLoading: true });
        const url = `api/ExternalOperation/RetrieveCreditApplication/` + param;
        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
            },
        }).then(handleResponse)
            .then(
            result => {
                if (result == null) {
                    dispatch(push('/login'));
                }
                    dispatch({ type: CreditabilityConstants.CREDITABILITY_GET_COMPANY_RESPONSE, isLoading: false, creditForm: result });
                },
                error => {
                    toast.warn("Error:" + error.error, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                })
    },

    SaveCompanyInfo: (state, id) => (dispatch) => {

        const url = `api/ExternalOperation/SaveCAFCompanyInfo`;

        return fetch(url, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Accept': 'application/json',
            },
            body: JSON.stringify({
                "CreditApplicationId": id,
                "CompanyTitle": state.CompanyTitle,
                "InBusinessSince": state.BusinessDate,
                "TypeOfBusiness": state.BusinessType,
                "ParentCompanyName": state.OtherCompanyName,
                "ParentInBusinessSince": state.OtherBusinessDate,
                "CAF_LegalFormTypeId": state.OperationType
            })
        })
            .then(handleResponse)
            .then(
                result => {
                    dispatch({ type: CreditabilityConstants.CREDITABILITY_POST_COMPANY_RESPONSE, actResult: result });
                    console.log('result', result)
                    toast.success("Company Information Successfully Added !", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    return result;
                },
                error => {
                    toast.warn("There is a problem !");
                    return error.error;
                }
            );
    },

    SaveContactInfo: (state, id) => (dispatch) => {
        console.log("function run", state);
        const url = `api/ExternalOperation/SaveCAFContactInfo`;
        dispatch({ type: CreditabilityConstants.CREDITABILITY_POST_CONTACT_REQUEST, isLoading: true });
        return fetch(url, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Accept': 'application/json',
            },
            body: JSON.stringify({
                "CreditApplicationId": id,
                "Title": state.ContactTitle,
                "FirstName": state.ContactFirstName,
                "LastName": state.ContactLastName,
                "Phone": state.ContactPhoneNumber,
                "Address": state.ContactAdress,
                "State": state.ContactState,
                "Zip": state.ContactZipCode,
                "City": state.ContactCity
            })
        })
            .then(handleResponse)
            .then(
                result => {
                    dispatch({ type: CreditabilityConstants.CREDITABILITY_POST_CONTACT_RESPONSE, isLoading: false });
                    console.log('result', result)
                    toast.success("Company Information Successfully Added !", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    return result;
                },
                error => {
                    toast.warn("There is a problem !");
                    return error.error;
                }
            );
    },
    saveBankRefInfo: (state, id) => (dispatch) => {
        var obj = { CreditApplicationId: id, BankRefData: state };
        console.log("function run", obj);
        const url = `api/ExternalOperation/SaveCAFBankReference`;
        dispatch({ type: CreditabilityConstants.CREDITABILITY_POST_BANKREFERENCE_REQUEST, isLoading: true });
        return fetch(url, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Accept': 'application/json',
            },
            body: JSON.stringify(obj)
        })
            .then(handleResponse)
            .then(
            result => {
                    
                    dispatch({ type: CreditabilityConstants.CREDITABILITY_POST_CONTACT_RESPONSE, isLoading: false });
                    toast.success("Company Information Successfully Added !", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    return result;
                },
                error => {
                    toast.warn("There is a problem !");
                    return error.error;
                }
            );
    },
    saveTradeRefForm: (state, id) => (dispatch) => {
        var obj = { CreditApplicationId: id, TradeRefData: state };
        console.log("function run", obj);
        const url = `api/ExternalOperation/SaveCAFTradeReference`;
        dispatch({ type: CreditabilityConstants.CREDITABILITY_POST_TRADEREFERENCE_REQUEST, isLoading: true });
        return fetch(url, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Accept': 'application/json',
            },
            body: JSON.stringify(obj)
        })
            .then(handleResponse)
            .then(
                result => {
                    dispatch({ type: CreditabilityConstants.CREDITABILITY_POST_TRADEREFERENCE_RESPONSE, isLoading: false });
                    console.log('result', result)
                    toast.success("Company Information Successfully Added !", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    return result;
                },
                error => {
                    toast.warn("There is a problem !");
                    return error.error;
                }
            );
    }
};

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                return Promise.reject({ status: response.status });
            }
            const error = text;
            return Promise.reject({ status: response.status, error });
        }
        return data;
    });
}


export const reducer = (state, action) => {
    state = state || initialState;
    if (action.type === CreditabilityConstants.CREDITABILITY_GET_COMPANY_REQUEST) {
        return {
            ...state,
            isLoading: true,
        }
    }
    if (action.type === CreditabilityConstants.CREDITABILITY_GET_COMPANY_RESPONSE) {
        return {
            ...state,
            isLoading: false,
            creditForm: action.creditForm
        }
    }
    if (action.type === CreditabilityConstants.CREDITABILITY_POST_COMPANY_REQUEST) {
        return {
            ...state,
            isLoading: true,
            creditForm: action.creditForm
        }
    }
    if (action.type === CreditabilityConstants.CREDITABILITY_POST_COMPANY_RESPONSE) {
        return {
            ...state,
            isLoading: false,
            actResult: action.actResult
        };
    }
    return state;
};


// WEBPACK FOOTER //
// ./src/store/CreditabilityStore.js